import { getConfigGeneral } from '../index';

var getContenidoTipoEjercicio = function getContenidoTipoEjercicio(state, zona) {
  var _zona$vinculo$split = zona.vinculo.split(','),
      id = _zona$vinculo$split[1];

  var carpetaEjercicios = getConfigGeneral(state).carpetaEjercicios || '';
  var contenido = {
    // id: zona.id,
    tipo: 'ejercicio',
    src: encodeURI('ejercicio.html?id=' + id + '&curso=' + carpetaEjercicios + '/curso/&res=' + carpetaEjercicios + '/res/')
  };
  return contenido;
};

export default getContenidoTipoEjercicio;